import { IpaType } from "../../phonemes/ipa";
import { ipaToSynthSymbols } from "../../speak/exact";
import { speakPhonemes } from "../../speak/speakPhonemes";
import { Ipa } from "../chart/Ipa";
import { IpaChartProps } from "../chart/IpaChart";
import { hasSample, speakSample } from "../chart/speakSample";

export function Affricates() {
  const affricates = [['p͡ɸ', 'b͡β'], ['p͡f', 'b͡v'], [], ['t̪͡θ', 'd̪͡ð'], ['t͡s', 'd͡z'], ['t̠͡ʃ', 'd̠͡ʒ'], ['ʈ͡ʂ', 'ɖ͡ʐ'], ['t͡ɕ', 'd͡ʑ'],
  ['c͡ç', 'ɟ͡ʝ'], ['k͡x', 'ɡ͡ɣ'], ['q͡χ', 'ɢ͡ʁ'], ['q͡χ', 'ɢ͡ʁ'], ['ʔ͡h', ''], ['ʡ͡ʜ', 'ʡ͡ʢ']];
  const lateral = [[], [], [], [], ['t͡ɬ', 'd͡ɮ'], [], ['t͡ꞎ', ''], [], ['ɟ͡ʎ̝', ''], ['k͡𝼄', 'ɡ͡ʟ̝']];
  const coarticulated = [[], [], ['k͡p', 'ɡ͡b']];
  const nasal = [['', 'm͡b'], [], ['', 'ŋ͡m'], [], ['', 'n͡d'], ['', 'n̠͡d̠ʒ'], [], [], [], ['', 'ŋ͡ɡ']];

  return (<>
    <h2>Affricates and Co-articulated consonants</h2>

    <table>
      <thead>
        <tr>
          <td></td>
          <th>Bilabial</th>
          <th>Labio<br />dental</th>
          <th>Labial<br />Velar</th>
          <th>Dental</th>
          <th>Alveolar</th>
          <th>Post<br />alveolar</th>
          <th>Retro<br />flex</th>
          <th>Alveolo<br />palatal</th>
          <th>Palatal</th>
          <th>Velar</th>
          <th>Uvular</th>
          <th>Pharyn<br />geal</th>
          <th>Glottal</th>
          <th>Epi<br />glottal</th>
        </tr>
      </thead>
      <tbody>
        <Row title='Affricate' symbols={affricates} />
        <Row title='Lateral' symbols={lateral} />
        <Row title='Co-art' symbols={coarticulated} />
        <Row title='Nasal' symbols={nasal} />
      </tbody>
    </table>
  </>)
}

/** create a table row of symbols, clicking to hear synth or sample audio */
export function Row(props: { title: string, symbols: string[][] }) {
  return (<tr>
    {props.title ? <th>{props.title}</th> : undefined}
    {props.symbols.map((item, i) => {
      if (item.length !== 2) {
        return <td key={i}></td>;
      }
      return <td key={i}><One ipa={item[0]} /><br /><One ipa={item[1]} /></td>
    })}
  </tr>);
}

/** a single phoneme with an option to hear synth or sample audio */
function One(props: { ipa: IpaType }) {
  if (props.ipa === '') {
    return <></>;
  }

  const p: IpaChartProps = {
    lookup(ipa: IpaType) { return ipa; },
    clicked(ipa: IpaType) { speakPhonemes(`ˈ${ipa}a | aˈ${ipa}a`, { speed: 110 }); },
    canClick(ipa: IpaType) { return true; },
    background(ipa: IpaType) { return ipaToSynthSymbols[ipa] !== undefined ? 'lightgreen' : '#f5d3d3ff' },
  };

  return (<>
    <Ipa s={props.ipa} p={p} />, <Sample ipa={props.ipa} />
  </>);
}

/** sample audio control */
function Sample(props: { ipa: IpaType }) {
  const className = hasSample(props.ipa) ? 'pointer' : 'play-error';
  return (<span onClick={() => speakSample(props.ipa)} className={className}>
    {props.ipa}
  </span>);
}
